import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '@fortem-monorepo/js-utilities';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
export const CodeBlock = ({ className, children }) => {
    const codeRef = useRef(null);
    const onCopyClick = () => {
        const innerText = codeRef.current?.innerText;
        if (innerText) {
            window.navigator.clipboard.writeText(innerText);
            toast.info('Copied code to clipboard.', {
                description: _jsx("span", { className: 'text-xs text-muted-foreground', children: innerText }),
            });
        }
    };
    return (_jsxs("code", { ref: codeRef, className: cn('relative bg-neutral-700 rounded-md p-3', className), children: [_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx(Button, { onClick: onCopyClick, size: "sm", variant: 'outline', className: 'absolute top-2 right-2 w-6 h-6 p-0!', children: _jsx(Copy, {}) }) }), _jsx(TooltipContent, { children: "Copy" })] }), _jsx("span", { className: 'text-white text-xs whitespace-pre-wrap', children: children })] }));
};
